import Axios from 'helpers/http'
import generateOrbitHostname from 'helpers/http/generateOrbitHostname'

import { VERSION_ONE_API_PREFIX } from '../../constants'

const OrbitApiV1 = new Axios(generateOrbitHostname(), VERSION_ONE_API_PREFIX)

export default OrbitApiV1
